module.exports = require("./fr-DJ.js");